<div class="main pt-0">
  <div class="section pt-0">
    <div class="container">
      <app-navbar-admin></app-navbar-admin>
      <ng-container *ngIf="!noLocation">
        <router-outlet></router-outlet>
      </ng-container>
      <div *ngIf="noLocation">
          <h2>No hay location</h2>
          <p>Selecciona una instalacion en el desplegable superior para continuar.</p>
      </div>
    </div>
  </div>
</div>
  
  
